import { CollectionPreferencesProps } from '@amzn/awsui-components-react/polaris/collection-preferences';
import { usePreferencesStrings } from '../../../hooks/localization/preferencesStrings';
import CollectionPreferences from '@amzn/awsui-components-react/polaris/collection-preferences';

export type PeoplePreferencesProps = {
  preferences: CollectionPreferencesProps.Preferences;
  onConfirm: NonNullable<CollectionPreferencesProps['onConfirm']>;
};

export function PeoplePreferences(props: PeoplePreferencesProps) {
  const namespaces = ['attendance', 'translation'];
  const propertyFilterStrings = usePreferencesStrings(
    'preferences',
    [5, 10, 25, 50, 100],
    namespaces
  );

  return <CollectionPreferences {...props} {...propertyFilterStrings} />;
}
